import type { AxiosResponse } from 'axios'
import qs from 'qs'
import axios from 'axios'

interface ExportData {
  [key: string]: string[] | string
}

interface ExportToWordApi {
  postWord: (data: ExportData) => Promise<AxiosResponse<ArrayBuffer>>
}

export default function useExportToWordApi(): ExportToWordApi {
  const baseURL = import.meta.env.VITE_AUNIVERS_SITEURL as string

  const arrayBufferCall = async (
    method: 'post',
    resource: string,
    data: ExportData
  ): Promise<AxiosResponse<ArrayBuffer>> => {
    return axios({
      withCredentials: true,
      method,
      baseURL,
      url: resource,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: qs.stringify(data),
      responseType: 'arraybuffer',
    })
  }

  const postWord = (data: ExportData) =>
    arrayBufferCall('post', '/export/word/image-and-fields', data)

  return {
    postWord,
  }
}
